module.exports = __webpack_public_path__ + "img/cp6-3.f026966f.jpg";